
import React, { Component } from 'react'
import * as actions from '../../actionTypes'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'

import LanguageSelect from './LanguageSelect'

class LanguageSelectContainer extends Component {
  componentDidMount() {
    if (!this.props.languages.length) {
      this.props.getSupportedLanguages()
    }
  }

  render() {
    const { 
      disabled, 
      requestLanguage, 
      lang, 
      languages, 
      isRequesting,
      getSupportedLanguages, 
      loading,
      sessionLang,
      ...rest 
    } = this.props
    return (
      !loading && (<LanguageSelect 
        disabled={disabled} 
        onChange={requestLanguage} 
        value={sessionLang || lang} 
        languages={languages}
        {...rest}
      />
    ))
  }
}

const mapStateToProps = state => ({
  disabled: !!state.counselingSession.sessionId,
  lang: state.globalSettings.lang,
  languages: state.globalSettings.supportedLanguages.languages,
  isRequesting: state.globalSettings.supportedLanguages.isRequesting,
  sessionLang: state.globalSettings.sessionLang
})

const mapDispatchToProps = dispatch => ({
  requestLanguage(lang) {
    const action = {type: actions.LANGUAGE_REQUESTED, payload: {lang}}
    dispatch(action)
  },
  getSupportedLanguages() {
    const action = { type: actions.SUPPORTED_LANG_REQUESTED }
    dispatch(action)
  }
})

LanguageSelectContainer.propTypes = {
  disabled: PropTypes.bool.isRequired,
  lang: PropTypes.string.isRequired,
  requestLanguage: PropTypes.func.isRequired,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      languageCode: PropTypes.string,
      languageId: PropTypes.number,
      languageName: PropTypes.string
    })
  ).isRequired,
  isRequesting: PropTypes.bool.isRequired,
  sessionLang: PropTypes.string
}

export default connect(mapStateToProps, mapDispatchToProps)(LanguageSelectContainer)



// WEBPACK FOOTER //
// ./src/components/language/LanguageSelectContainer.js